import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { Select } from '@/shared/components/Select'
import { countryFlag } from '@/shared/lib/country'

/** App languages with the flag of their reference country. */
const LANGUAGES = [
  { code: 'en', label: 'English', country: 'GB' },
  { code: 'ro', label: 'Română', country: 'RO' },
  { code: 'es', label: 'Español', country: 'ES' },
  { code: 'bg', label: 'Български', country: 'BG' },
  { code: 'hr', label: 'Hrvatski', country: 'HR' },
  { code: 'cs', label: 'Čeština', country: 'CZ' },
  { code: 'da', label: 'Dansk', country: 'DK' },
  { code: 'nl', label: 'Nederlands', country: 'NL' },
  { code: 'et', label: 'Eesti', country: 'EE' },
  { code: 'fi', label: 'Suomi', country: 'FI' },
  { code: 'fr', label: 'Français', country: 'FR' },
  { code: 'de', label: 'Deutsch', country: 'DE' },
  { code: 'el', label: 'Ελληνικά', country: 'GR' },
  { code: 'hu', label: 'Magyar', country: 'HU' },
  { code: 'ga', label: 'Gaeilge', country: 'IE' },
  { code: 'it', label: 'Italiano', country: 'IT' },
  { code: 'lv', label: 'Latviešu', country: 'LV' },
  { code: 'lt', label: 'Lietuvių', country: 'LT' },
  { code: 'mt', label: 'Malti', country: 'MT' },
  { code: 'pl', label: 'Polski', country: 'PL' },
  { code: 'pt', label: 'Português', country: 'PT' },
  { code: 'sk', label: 'Slovenčina', country: 'SK' },
  { code: 'sl', label: 'Slovenščina', country: 'SI' },
  { code: 'sv', label: 'Svenska', country: 'SE' },
] as const

/** Language dropdown with country flags, on the shared Select. */
export function LanguageSwitcher() {
  const { t, i18n } = useTranslation()
  const current = LANGUAGES.find((l) => l.code === i18n.resolvedLanguage) ?? LANGUAGES[0]
  const options = useMemo(
    () =>
      LANGUAGES.map((language) => ({
        value: language.code,
        label: language.label,
        leading: <span aria-hidden>{countryFlag(language.country)}</span>,
      })),
    [],
  )

  return (
    <Select
      value={current.code}
      onChange={(code) => void i18n.changeLanguage(code)}
      options={options}
      size="sm"
      align="end"
      fullWidth={false}
      aria-label={t('actions.language')}
      className="font-semibold"
    />
  )
}
